import GoogleAnalyticsEvent from "./GoogleAnalyticsEvent";
import GoogleAnalyticsModel from "./GoogleAnalyticsModel";
import GoogleAnalyticsCommand from './GoogleAnalyticsCommand';
import GoogleAnalyticsService from "../../../lib/html5-software-library/src/ranj/analytics/GoogleAnalyticsService";
import InitGoogleAnalyticsTask from "./InitGoogleAnalyticsTask";
import AbstractInstaller from "../app/core/AbstractInstaller";

export default class GoogleAnalyticsInstaller extends AbstractInstaller {

    constructor(injector, commands, mediatorMap) {
        super(injector, commands, mediatorMap);

        //soma context:        
        injector.mapClass("googleAnalyticsModel", GoogleAnalyticsModel, true);
        injector.mapClass("googleAnalyticsService", GoogleAnalyticsService, true);
        commands.add(GoogleAnalyticsEvent.INIT, GoogleAnalyticsCommand);
        commands.add(GoogleAnalyticsEvent.USER, GoogleAnalyticsCommand);
        commands.add(GoogleAnalyticsEvent.DIMENSION, GoogleAnalyticsCommand);
        commands.add(GoogleAnalyticsEvent.EVENT, GoogleAnalyticsCommand);
        commands.add(GoogleAnalyticsEvent.ERROR, GoogleAnalyticsCommand);
        commands.add(GoogleAnalyticsEvent.SESSION_START, GoogleAnalyticsCommand);
        commands.add(GoogleAnalyticsEvent.SESSION_END, GoogleAnalyticsCommand);
        commands.add(GoogleAnalyticsEvent.FILL, GoogleAnalyticsCommand);

        this._addStartupTask(InitGoogleAnalyticsTask, "initGA", 1);

        this._addDestroyEvents(GoogleAnalyticsEvent.SESSION_END);
    }
}